import classnames from "classnames";
import * as PropTypes from "prop-types";
import * as React from "react";
import Label from "../Label/index";

class Textarea extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
        this.setFocus.bind(this);
    }
    setFocus() {
    }
    render() {
        const {
            id,
            name,
            label,
            labelHidden,
            placeholder,
            error,
            onChange,
            ref,
            ...rest} = this.props;

        const setClasses = classnames("field",
            error && "is-danger");

        const labelMarkup = (
            <Label className="label" htmlFor={id} label={`${label}`}/>
        );

        const formControl = classnames("textarea",
            error && "is-danger");

        const input = React.createElement("textarea", {
            ...rest,
            id,
            name,
            label,
            placeholder,
            onChange,
            onClick: this.setFocus,
            ref,
            className: formControl
        });

        const setClassesControl = classnames("control", error && "is-danger");

        return (
            <div className={setClasses}>
                {label && !labelHidden && labelMarkup}
                <div className={setClassesControl}>
                    {input}
                </div>
                {error && <small className="text-danger">{error}</small>}
            </div>
        );
    }
}

Textarea.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
    labelHidden: PropTypes.bool,
    onChange: PropTypes.func,
    onClick: PropTypes.func,
    error: PropTypes.string,
    required: PropTypes.bool,
    ref: PropTypes.any,
    placeholder: PropTypes.string
};

export default Textarea;
